"use client";

import { FE_MIGRATE_DISCOVER_LAYOUT_CALLS_250424 } from "@faire/retailer-settings/FE_MIGRATE_DISCOVER_LAYOUT_CALLS_250424";
import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingAndAssignMigrateDiscoverLayoutCalls = (): boolean => {
  useAssignSetting(FE_MIGRATE_DISCOVER_LAYOUT_CALLS_250424);
  return useSetting(FE_MIGRATE_DISCOVER_LAYOUT_CALLS_250424);
};
